import React, { useState, createContext, useContext } from "react";
import { getElementYId } from "../utils";
export const VisibleValuesContext = createContext({
    visibleValues: {},
    removeAllLegendRows: () => { },
    showAllLines: () => { },
    toggleVariable: () => { },
    setVisibleValues: () => { },
});
export const VisibleValuesContainer = ({ children, initialVisibleValues, }) => {
    const [visibleValues, setVisibleValues] = useState(initialVisibleValues);
    React.useEffect(() => {
        setVisibleValues(initialVisibleValues);
    }, [initialVisibleValues]);
    const setAllTo = (newValue) => {
        setVisibleValues(Object.keys(visibleValues).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: newValue })), {}));
    };
    const removeAllLegendRows = () => {
        setAllTo(false);
    };
    const showAllLines = () => {
        setAllTo(true);
    };
    const toggleVariable = (line) => {
        setVisibleValues((prevLines) => (Object.assign(Object.assign({}, prevLines), { [line]: !prevLines[line] })));
    };
    return (React.createElement(VisibleValuesContext.Provider, { value: {
            visibleValues,
            setVisibleValues,
            removeAllLegendRows,
            showAllLines,
            toggleVariable,
        } }, children));
};
export const useVisibleValues = () => {
    return useContext(VisibleValuesContext);
};
export const getInitialVisibleValues = ({ graph, ignoreFileName, }) => {
    const values = graph.elements.map((_, i) => getElementYId(graph.elements[i], ignoreFileName));
    return values.reduce((acc, title) => (Object.assign(Object.assign({}, acc), { [title]: true })), {});
};
//# sourceMappingURL=VisibleValuesContext.js.map